import { evalBoolFeature } from './evalBoolFeature.js';

const room = (feat, { short }) => {
    const { key, value } = feat.values[0];
    switch (key) {
        case '11':
            return short ? '+10 Locali' : 'Più di 10 Locali';
        default:
            return `${value} ${value === '1' ? 'Locale' : 'Locali'}`;
    }
};
const mileage = (feat) => `${feat.values[0].value} km`;
const floor = (feat, { short }) => {
    const { key, value } = feat.values[0];
    switch (key) {
        case '1':
            return short ? 'Interr.' : value;
        case '2':
            return short ? 'Semint.' : value;
        case '3':
            return short ? 'Rialz.' : value;
        case '4':
            return short ? 'Piano T' : 'Terra';
        case '12':
            return short ? '+7° Piano' : 'Oltre il 7° Piano';
        default:
            return `${value}° Piano`;
    }
};
const bathrooms = (feat, { short }) => {
    const { key, value } = feat.values[0];
    switch (key) {
        case '4':
            return short ? '+3 Bagni' : 'Più di 3 Bagni';
        default:
            return `${value} ${value === '1' ? 'Bagno' : 'Bagni'}`;
    }
};
const multiLevel = (feat) => evalBoolFeature(feat) ? 'Su più livelli' : '';
const furnished = (feat) => evalBoolFeature(feat) ? 'Arredata' : '';
const roomType = (feat) => {
    const { key, value } = feat.values[0];
    switch (key) {
        case '1':
            return 'Singola';
        case '2':
            return 'Condivisa';
        default:
            return value;
    }
};

export { bathrooms, floor, furnished, mileage, multiLevel, room, roomType };
//# sourceMappingURL=formatters.js.map
